import React, { useState, useEffect, useContext } from "react";
import Select from "react-select";
import { MDBInput } from "mdb-react-ui-kit";
import apiService from "../../Services/apiServices";
import { useToasts } from "react-toast-notifications";
import Search from "../../PageComponents/Search/Search";
import { confirmAlert } from "react-confirm-alert";
import helper from "../../Services/helper";
import globals from "../../Services/globals";
import UserPermissionContext from "../Context/UserPermissionContext";

function ReportsDashboard(props) {


  useEffect(() => {
    var user = globals().getLogedInUser();
    setUsrPlan(user.plan);
    // getPermissions();
    document.getElementById('navi')?.classList.add("nav-mobile")
    return () => {
      document.getElementById('navi')?.classList.remove("nav-mobile")
    }
  }, [])
  const { addToast } = useToasts();
  const [usrPlan, setUsrPlan] = useState();
  const { userPermission } = useContext(UserPermissionContext);

  const displayMsg = () => {
    addToast("së shpejti ky raport do të jet aktiv", { appearance: 'info', autoDismiss: true, });
  }

  // const getPermissions = () => {
  //   var params = `&username=${globals().getLogedInUser().data.username}`;
  //   apiService().query('getUserPermissions',params)
  //       .then((response) => {
  //        if(response.success){
  //          setUserPermissions(response.data)
  //        }
  //       })
  // }

  return (
    <div style={{ height: "85vh" }}>
      <div className="container-fluid mt-5">
        <div className="row">
          <div className="col-12 mb-4">
            <h4 className="m-0 mt-1 font-weight-bold text-center text-primary">{helper().translate("REPORTS")}</h4>
          </div>
          <hr style={{ width: "97%", margin: "auto", height: "2px", color: "black", backgroundColor: "black" }}></hr>
        </div>
        <div className="row mt-5">
        {usrPlan >= 4 &&<div className={`col-xl-4 col-md-6 mb-4  ${userPermission?.find((f) => f.moduleName === 'FINANCIAL_REPORTS')?.allowView ? "" : "pe-none"}`}>
            <div className="card  border-bottom-primary shadow h-100 py-2">
              <div className="card-body">
                <div className="row no-gutters align-items-center">
                  <div className="col mr-2">
                    <div className="row pLeft35">
                      <h5 className="text-xl text-left font-weight-bold text-dark  mb-1">{helper().translate("FINANCIAL_REPORTS")}</h5>
                    </div>
                    <div className="row pLeft35 pt-2">
                      <div className="col text-left">
                        <div div className="row  reportsBordersFi  ">
                          <a href="#/report/financial/balance-sheet"  >{helper().translate("BALANCE_SHEET")}</a>
                        </div>
                        <div className="row reportsBordersFi  mt-1 ">
                          <a href="#/report/financial/income-statement"  >{helper().translate("INCOME_STATEMENT")}</a>
                        </div>
                        <div className="row reportsBordersFi  mt-1">
                          <a href="#/reports" onClick={displayMsg} >{helper().translate("CASH_FLOW")}</a>
                          {/* href="#/report/financial/cash-flow" */}
                        </div>
                        <div className="row reportsBordersFi  mt-1">
                          <a href="#/reports" onClick={displayMsg}  >{helper().translate("SHAREHOLDER_EQUITY")}</a>
                          {/* href="#/report/financial/shareholder-equity" */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>}
          {usrPlan >= 4 &&<div className={`col-xl-4 col-md-6 mb-4  ${userPermission?.find((f) => f.moduleName === 'TAX_REPORTS')?.allowView ? "" : "pe-none"}`}>
            <div className="card  border-bottom-success shadow h-100 py-2">
              <div className="card-body">
                <div className="row no-gutters align-items-center">
                  <div className="col mr-2">
                    <div className="row pLeft35">
                      <h5 className="text-xl text-left font-weight-bold text-dark  mb-1">{helper().translate("TAX_REPORTS")}</h5>
                    </div>
                    <div className="row  pLeft35 pt-2">
                      <div className="col text-left">
                        <div div className="row  reportsBordersTax  ">
                          <a href="#/report/atk-purchase-book" >{helper().translate("ATK_PURCHASE_BOOK")}</a>
                        </div>
                        <div div className="row  reportsBordersTax   mt-1 ">
                          <a href="#/report/atk-sale-book" >{helper().translate("ATK_SALE_BOOK")}</a>
                        </div>
                        <div className="row  reportsBordersTax   mt-1 ">
                          <a href="#/reports" onClick={displayMsg}>{helper().translate("PAYMENT_LIST")}</a>
                        </div>
                        <div className="row reportsBordersTax    mt-1 ">
                          <a href="#/report/atk/cashbox-book" >{helper().translate("CASHBOX_BOOK")}</a>
                        </div>
                        <div className="row reportsBordersTax   mt-1 ">
                          <a href="#/report/atk/bank-book" >{helper().translate("BANK_BOOK")}</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>}
          {usrPlan >= 4 &&<div className={`col-xl-4 col-md-6 mb-4  ${userPermission?.find((f) => f.moduleName === 'ACCOUNTING_REPORTS')?.allowView ? "" : "pe-none"}`}>
            <div className="card  border-bottom-danger shadow h-100 py-2">
              <div className="card-body">
                <div className="row no-gutters align-items-center">
                  <div className="col ">
                    <div className="row pLeft35">
                      <h5 className="text-xl text-left font-weight-bold text-dark  mb-1">{helper().translate("ACCOUNTING_REPORTS")}</h5>
                    </div>
                    <div className="row row-cols-1 row-cols-md-2 pt-2  ps-md-4 text-left  pLeft35">
                      <div div className="col-8 col-sm-12 text-left reportsBordersAcc border border-white  ">
                        <a href="#/report/rpt-trial-balance"  >{helper().translate("TRIAL_BALANCE")}</a>
                      </div>
                      <div div className="col-8 col-sm-12  reportsBordersAcc border border-white   ">
                        <a href="#/report/rpt-general-book"  >{helper().translate("GENERAL_LEDGER")}</a>
                      </div>
                      <div className="col-8 col-sm-12  reportsBordersAcc border border-white   mt-1">
                        <a href="#/report/rpt-list-of-assets"  >{helper().translate("LIST_OF_ASSETS")}</a>
                      </div>
                      <div className="col-8 col-sm-12  reportsBordersAcc  border border-white  mt-1">
                        <a href="#/reports" onClick={displayMsg}>{helper().translate("LIST_OF_ASSETS_BY_USER")}</a>
                      </div>
                      <div className="col-8 col-sm-12  reportsBordersAcc border border-white   mt-1">
                        <a href="#/report/rpt-purchase-book/1"  >{helper().translate("GOODS_PURCHASE_BOOK")}</a>
                      </div>
                      <div className="col-8 col-sm-12  reportsBordersAcc border border-white   mt-1">
                        <a href="#/report/rpt-purchase-book/3">{helper().translate("EXPENSES_BOOK")}</a>
                      </div>
                      <div className="col-8 col-sm-12  reportsBordersAcc border border-white   mt-1">
                        <a href="#/report/rpt-purchase-book/2" >{helper().translate("INVESTMENT_BOOK")}</a>
                      </div>
                      <div className="col-8 col-sm-12  reportsBordersAcc  border border-white  mt-1">
                        <a href="#/report/rpt-sale-book"  >{helper().translate("SALES_BOOK")}</a>
                      </div>
                      <div className="col-8 col-sm-12  reportsBordersAcc border border-white   mt-1">
                        <a href="#/report/rpt-internal-movement-books"  >{helper().translate("INTERNAL_MOVEMENT_BOOK")}</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>}
          <div className={`col-xl-4 col-md-6 mb-4  ${userPermission?.find((f) => f.moduleName === 'STOCKS_REPORTS')?.allowView ? "" : "pe-none"}`}>
            <div className="card  border-bottom-warning shadow h-100 py-2">
              <div className="card-body">
                <div className="row no-gutters align-items-center">
                  <div className="col mr-2">
                    <div className="row pLeft35">
                      <h5 className="text-xl text-left font-weight-bold text-dark  mb-1">{helper().translate("STOCKS_REPORTS")}</h5>
                    </div>
                    <div className="row pt-2 pLeft35">
                      <div className="col text-left">
                        <div div className="row  reportsBordersSt   mt-1 ">
                          <a href="#/report/stocks/warehouse" >{helper().translate("STOCKS_IN_WAREHOUSES")}</a>
                        </div>
                        <div className="row  reportsBordersSt   mt-1">
                          <a
                            // href="#/report/stocks/itemshistory"
                            href="#/reports" onClick={displayMsg}
                          >{helper().translate("ARTICLE_HISTORY")}</a>
                        </div>
                        <div className="row reportsBordersSt   mt-1">
                          <a href="#/report/stocks/articlecard" >{helper().translate("ARTICLE_CARD")}</a>
                        </div>
                        <div className="row reportsBordersSt   mt-1">
                          <a href="#/report/stocks/items-with-sale-price"  >{helper().translate("LIST_OF_ITEMS_WITH_SALE_PRICE")}</a>
                        </div>
                        <div className="row reportsBordersSt   mt-1">
                          <a href="#/report/item-profitability-list" >{helper().translate("ARTICLES_BY_PROFITABILITY")}</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`col-xl-4 col-md-6 mb-4  ${userPermission?.find((f) => f.moduleName === 'PURCHASE_REPORTS')?.allowView ? "" : "pe-none"}`}>
            <div className="card  border-bottom-info shadow h-100 py-2">
              <div className="card-body">
                <div className="row no-gutters align-items-center">
                  <div className="col mr-2">
                    <div className="row pLeft35">
                      <h5 className="text-xl text-left font-weight-bold text-dark  mb-1">{helper().translate("PURCHASE_REPORTS")}</h5>
                    </div>
                    <div className="row pt-2 pLeft35">
                      <div className="col text-left">
                        <div div className="row reportsBordersPu   mt-1 ">
                          <a href="#/report/supplier/accounts-payable" >{helper().translate("ACCOUNTS_PAYABLE")}</a>
                        </div>
                        <div className="row  reportsBordersPu   mt-1">
                          <a href="#/report/supplier/supplier-card" >{helper().translate("SUPPLIER_CARD")}</a>
                        </div>
                        <div className="row reportsBordersPu   mt-1">
                          <a href="#/report/purchases-in-details" >{helper().translate("PURCHASES_IN_DETAIL")}</a>
                        </div>
                        <div className="row reportsBordersPu   mt-1">
                          <a href="#/report/supplier/top-suppliers"  >{helper().translate("TOP_SUPPLIERS")}</a>
                        </div>
                        <div className="row reportsBordersPu   mt-1">
                          <a href="#/report/purchases-terms-of-payments" >{helper().translate("WAITING_PAYMENT_LIST")}</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`col-xl-4 col-md-6 mb-4  ${userPermission?.find((f) => f.moduleName === 'SALE_REPORTS')?.allowView ? "" : "pe-none"}`}>
            <div className="card  border-bottom-dark shadow h-100 py-2">
              <div className="card-body">
                <div className="row no-gutters align-items-center">
                  <div className="col mr-2">
                    <div className="row pLeft35">
                      <h5 className="text-xl text-left font-weight-bold text-dark mb-1">{helper().translate("SALE_REPORTS")}</h5>
                    </div>
                    <div className="row pt-2 pLeft35 ">
                      <div className="col text-left">
                        <div div className="row reportsBordersSa   mt-1 ">
                          <a href="#/report/buyer/accounts-receivable" >{helper().translate("ACCOUNTS_RECIVABLE")}</a>
                        </div>
                        <div className="row reportsBordersSa   mt-1 ">
                          <a href="#/report/buyer/buyer-card" >{helper().translate("BUYER_CARD")}</a>
                        </div>
                        <div className="row reportsBordersSa   mt-1">
                          <a href="#/report/buyer/sales-in-detail"  >{helper().translate("SALES_IN_DETAIL")}</a>
                        </div>
                        <div className="row reportsBordersSa   mt-1">
                          <a href="#/report/supplier/top-buyers"  >{helper().translate("TOP_BUYERS")}</a>
                        </div>
                        <div className="row reportsBordersSa   mt-1">
                          <a href="#/report/sales-terms-of-payments">{helper().translate("WAITING_PAYMENT_LIST")}</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}


export default ReportsDashboard;